import type { Dimensions, Viewport } from '../../core';
import type { MindmapState } from '../types';

/** Sets the viewport as given. Like v11 `setViewport`, the zoom is not clamped to the limits. */
export const withViewport = (viewport: Viewport): Pick<MindmapState, 'viewport'> => ({ viewport: { ...viewport } });

/** New zoom limits for later pan/zoom gestures; the current viewport is left as it is (v11). */
export const withZoomLimits = (minZoom: number, maxZoom: number): Pick<MindmapState, 'minZoom' | 'maxZoom'> => ({
  minZoom,
  maxZoom,
});

export const withPaneSize = ({ width, height }: Dimensions): Pick<MindmapState, 'paneSize'> => ({
  paneSize: { width, height },
});
